import React, {useState} from "react";
import ReactTable from "react-table-v6"
import { IconButton, Tooltip } from "@material-ui/core";
import { AddCircle, Download } from "@mui/icons-material";

import 'react-table-v6/react-table.css'
import { Image } from "@aws-amplify/ui-react";

import FileUploadForm from "../Files/FileUploadForm";
import { getFullFileURL } from "../../services/FileService";

const FileList = (props) => {
    const[showUploadModal, setShowUploadModal] = useState(false)
    const width  = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

    const onDownload = (file) => {
        if (file.source === "s3") {
			getFullFileURL(file.url).then(href => {
				const a = document.createElement('a');
				a.style.display = 'none';
				a.href = href;
				a.setAttribute('target', `_blank`);
				document.body.appendChild(a);
				a.click();
			}).catch(err => {
				console.log(err)
			});
        } else {
            const link = document.createElement("a");
            link.href = file.url;
            link.style.display = 'none';
            link.click();
        }

      };

    const columns = [
        {
            Header: '',
            accessor: 'thumbnail_sm',
            style: {paddingTop: 15},
            Cell: p => {
                return <Image src={p.value} />
            },
            show: width > 1000,
            width: 100
        },
        {
            Header: 'File Name',
            accessor: 'name',
            style: {paddingTop: 15},
        },
        {
            Header: 'Type',
            accessor: 'type',
            style: {paddingTop: 15}
        },
        // {
        //     Header: 'Size',
        //     accessor: 'size',
        //     style: {paddingTop: 15},
        //     Cell: p => {
        //         return p.value && (p.value + " kb")
        //     },
        //     show: width > 1000
        // },
        // {
        //     Header: 'Uploaded By',
        //     accessor: 'uploaded_by',
        //     style: {paddingTop: 15},
        //     Cell: p => {
        //         return p.value && (p.value + " (" + p.original.upload_date.toLocaleDateString() + ")")
        //     },
        //     show: width > 1000
        // },
        {
            Header: 'Download',
            accessor: 'url',
            Cell: p => {

                return <IconButton 
                            variant="contained" 
                            color="primary"
                            aria-label={"Download file" }
                            size={"small"}
                            onClick={() => onDownload(p.original)}>
                            <Download />
                        </IconButton>
            },
            width: 100
        },
    ]
         
        return (
            <div className="equipment-list">
                <FileUploadForm open={showUploadModal} context={props.context} id={props.id} onSubmit={() => props.filesAccessor()} closeModal={() => setShowUploadModal(false)} s/>
                <div className="space-add-mode">  
                { props.files && props.files.length > 0 ?
                    <Tooltip title="Add Additional Files">   
                        <IconButton 
                                    variant="contained" 
                                    color="primary"
                                    aria-label={"Add files" }

                                    onClick={() => {
                                        setShowUploadModal(true)
                                }}>
                                <AddCircle style={{fill: "#00b088", background: "white", transform: "scale(1.0)"}}/>
                        </IconButton>
                    </Tooltip>
                : null}
                </div> 
                <div className="section-header">Files </div>
                { props.files && props.files.length > 0 ?
                    <div className="point-list-table">
                        <ReactTable key={(props.files && props.files.length) || 0}
                            data={props.files || []}
                            columns={columns}
                            minRows={0}
                            defaultPageSize={10}
							showPagination={props.files && props.files.length > 10}
                        />
                    </div>
                :
                <div className="bulk_add_prompt">
                    <IconButton 
                                    variant="contained" 
                                    color="primary"
                                    aria-label={"Add file" }

                                    onClick={() => {
                                        setShowUploadModal(true)
                                }}>
                            <AddCircle style={{fill: "#00b088", background: "white"}}/>
                    </IconButton>
                    There are currently no files configured.  Add some now!
                </div>
                }


            </div>



        )
}

export default FileList;
